module.exports = __webpack_public_path__ + "img/orange-bg.61d37131.png";